<template>
  <van-popup v-model="show" class="popup">
    即将打开双鸭山税务云掌上办小程序
    <wx-open-launch-weapp
      id="launch-btn"
      appid="wx720072cd851842a1"
      :path="`pages/login/login?gzhphone=${gzhphone}&gzhtaxnum=${gzhtaxnum}&gzhtaxname=${gzhtaxname}`"
    >
      <script type="text/wxtag-template">
      <style>.btn { width:80%;height:40px;background-color:#0276f3;color:#fff;border-radius:20px;font-size:16px;margin-top:16px }</style>
        <button class="btn">打开小程序</button>
      </script>
    </wx-open-launch-weapp>
  </van-popup>
</template>

<script>
export default {
  data(){
    return{
      show:true,
      gzhphone:sessionStorage.getItem("sjh"),
      gzhtaxnum:sessionStorage.getItem("qysh"),
      gzhtaxname:sessionStorage.getItem("qymc"),
    }
  },
  created(){
    this.wechatApplet();
  }
}
</script>

<style scoped>
.popup{
  width: 85%;
  padding: 1rem 0;
  border-radius: 0.16rem;
}
</style>